'use strict';/* global define:false */define('modules/privacy/states/privacy-admin/index',['require','text!./template.html'],function(require){'use strict';return{views:{'body@app':{template:require('text!./template.html')}}};});
